<pf-background />

@if (auth.isAuthenticated() && !hidesSideNav()) {
  <pf-nav />
}

<main
  class="app-main"
  [class.app-main--with-nav]="auth.isAuthenticated() && !hidesSideNav()"
  [class.app-main--public]="hidesHeader()"
>
  @if (!hidesHeader()) {
    <header class="app-header">
      <div class="app-brand">
        <p class="app-brand__kicker">Diario financiero personal</p>
        <h1 class="app-logo">Porto<span class="app-logo__filo">filo</span></h1>
      </div>
      <div class="app-header__actions">
        <div class="lang-switcher">
          @for (lang of langs; track lang) {
            <button type="button" [class.active]="lang === currentLang" (click)="setLang(lang)">
              {{ lang.toUpperCase() }}
            </button>
          }
        </div>
        @if (auth.isAuthenticated()) {
          <button type="button" class="logout-btn" (click)="onLogout()">
            {{ 'app.logout' | translate }}
          </button>
        }
      </div>
    </header>
  }
  <router-outlet />
</main>
